import React, { useEffect, useRef, useState } from 'react';
import Api from '../../../../api/Api';
import LockIcon from '../../../../assets/icon/Lock.svg?react';
import UserIcon from '../../../../assets/icon/User.svg?react';
import useAuthStore from '../../../../store/authStore';
import useHomeStore from '../../../../store/homeStore';
import { useMarkerStore } from '../../../../store/markerStore';
import styles from '../style/LoginButton.module.scss';
import SignUp from './SignUpButton';

export default function LoginButton() {
  const user = useAuthStore((state) => state.user);
  const clearAuth = useAuthStore((state) => state.clearAuth);
  const setAddMarkerMode = useMarkerStore((state) => state.setAddMarkerMode);
  const setShowUserProfile = useHomeStore((state) => state.setShowUserProfile);
  const [showDropDown, setShowDropDown] = useState(false);
  const [showLoginDropDown, setShowLoginDropDown] = useState(false);
  const [showSigUp, setShowSignUp] = useState(false);

  const logout = React.useCallback(() => {
    // Reset user tracking in Matomo
    const _paq = (window._paq = window._paq || []);
    _paq.push(['resetUserId']);
    _paq.push(['appendToTrackingUrl', 'new_visit=1']);
    _paq.push(['trackPageView']);
    _paq.push(['appendToTrackingUrl', '']);
    // When login status changes we need to clean context
    clearAuth();
    setAddMarkerMode(false);
    Api.clearForgeryToken();
    (window.top || window).location.assign(
      `${Api.SERVER_DOMAIN}${Api.IISSite}/auth/signout`
    );
  }, [clearAuth, setAddMarkerMode]);

  const handleOnLogout = () => {
    logout();
  };

  const handleLogin = React.useCallback(() => {
    sessionStorage.setItem('skipCacheModalOnce', '1');
    (window.top || window).location.assign(
      `${Api.SERVER_DOMAIN}${
        Api.IISSite
      }/auth/signin?redirectUrl=${encodeURIComponent(window.location.origin)}`
    );
  }, []);

  async function onUserProfileClick() {
    if (user?.authenticated) {
      setShowUserProfile(true);
    }
  }

  const handleSingUp = React.useCallback(() => {
    setShowSignUp(true);
  }, []);

  const handleClickOutside = (event: any) => {
    if (refOne.current && !refOne.current.contains(event.target)) {
      setShowDropDown(false);
      setShowLoginDropDown(false);
    }
  };

  const refOne = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  return (
    <>
      <div
        ref={refOne}
        className={`${styles.dropdown}`}
        data-testid='Login_dropdown_trigger'
        onClick={() => {
          if (user?.authenticated) {
            setShowDropDown(!showDropDown);
            return;
          }
          setShowLoginDropDown(!showLoginDropDown);
        }}
      >
        <div className={styles.loginButton}>
          <div className={styles.text}>
            {user?.authenticated ? user?.userName : 'Sign in'}
          </div>
          <div className={styles.circle}>
            {!user?.authenticated ? (
              <LockIcon />
            ) : (
              <span>
                {user?.firstName?.charAt(0) || user?.lastName?.charAt(1) ? (
                  <>
                    {user?.firstName?.charAt(0)}
                    {user?.lastName?.charAt(0)}
                  </>
                ) : (
                  <UserIcon />
                )}
              </span>
            )}
          </div>
        </div>
        <div className={`${showDropDown ? styles.active : ''}`}>
          <div className={styles.dropdownContent}>
            <div
              id='Header-SignOut_Button'
              data-testid='Header-SignOut_Button'
              onClick={handleOnLogout}
            >
              Sign out
            </div>
            <div
              id='Header-MyAccount_Button'
              data-testid='Header-MyAccount_Button'
              onClick={onUserProfileClick}
            >
              My Account
            </div>
          </div>
        </div>
        <div className={`${showLoginDropDown ? styles.active : ''}`}>
          <div className={styles.dropdownContent}>
            <div
              id='Header-SignIn_Button'
              onClick={handleLogin}
              data-testid='SignIn_Button'
            >
              Sign In
            </div>
            <div
              id='Header-SignUp_Button'
              onClick={handleSingUp}
              data-testid='SignUp_Button'
            >
              Sign Up
            </div>
          </div>
        </div>
      </div>
      <SignUp open={showSigUp} setOpen={setShowSignUp}></SignUp>
    </>
  );
}
